var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVendorsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25732 8.41504V11.7825C2.25732 15.15 3.60732 16.5 6.97482 16.5H11.0173C14.3848 16.5 15.7348 15.15 15.7348 11.7825V8.41504",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00036 9C10.3729 9 11.3854 7.8825 11.2504 6.51L10.7554 1.5H7.25286L6.75036 6.51C6.61536 7.8825 7.62786 9 9.00036 9Z",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7326 9C15.2476 9 16.3576 7.77 16.2076 6.2625L15.9976 4.2C15.7276 2.25 14.9776 1.5 13.0126 1.5H10.7251L11.2501 6.7575C11.3776 7.995 12.4951 9 13.7326 9Z",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.23028 9C5.46778 9 6.58528 7.995 6.70528 6.7575L6.87028 5.1L7.23028 1.5H4.94278C2.97778 1.5 2.22778 2.25 1.95778 4.2L1.75528 6.2625C1.60528 7.77 2.71528 9 4.23028 9Z",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.75C7.7475 12.75 7.125 13.3725 7.125 14.625V16.5H10.875V14.625C10.875 13.3725 10.2525 12.75 9 12.75Z",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorsIcon);
export default __webpack_public_path__ + "static/media/vendors-icon.84277d3420b7960032508254af7521af.svg";
export { ForwardRef as ReactComponent };